export default __webpack_public_path__ + "static/media/Boots of the Valiant.45c3a61b.jpg";